import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
  const { colors } = useContextState()
  return {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      '&.flex-j-e': {
        justifyContent: 'end',
      },
    },
    add: {
      fontSize: '2rem',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
        color: colors.color4,
      },
    },
    titleEvidences: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    setting: {
      display: 'flex',
      justifyContent: 'end',
      '& .MuiButton-root': {
        fontSize: '10px',
        color: colors.color4,
      },
      '& .delete': {
        color: colors.color12,
      }
    },
    section: {
      marginBottom: '32px'
    },
    positionFilter: {
      position: 'relative'
    },
    headerTableActions:{
      justifyItems:'center'
    },
    baseMenu: {
      '& .MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper': {
        boxShadow: `1px 1px ${colors.color13}30`,
      },
    },
  }
}

export { useStyles }
